/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ad_Template_Min_Gap_TextInputs */

const en_ad_template_min_gap_text = /** @type {(inputs: Ad_Template_Min_Gap_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enter the minimum gap (in seconds) between events. Gaps at or above this value will get a new AD event.`)
};

const fr_ad_template_min_gap_text = /** @type {(inputs: Ad_Template_Min_Gap_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saisissez l'écart minimal (en secondes) entre les événements. Les écarts supérieurs ou égaux à cette valeur recevront un nouvel événement AD.`)
};

const de_ad_template_min_gap_text = /** @type {(inputs: Ad_Template_Min_Gap_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geben Sie die Mindestlücke (in Sekunden) zwischen Ereignissen ein. Lücken ab diesem Wert erhalten ein neues AD-Ereignis.`)
};

const it_ad_template_min_gap_text = /** @type {(inputs: Ad_Template_Min_Gap_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inserisci l'intervallo minimo (in secondi) tra gli eventi. Gli intervalli pari o superiori a questo valore riceveranno un nuovo evento AD.`)
};

const ru_ad_template_min_gap_text = /** @type {(inputs: Ad_Template_Min_Gap_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Введите минимальный интервал (в секундах) между событиями. Интервалы, равные или превышающие это значение, получат новое событие AD.`)
};

const es_ad_template_min_gap_text = /** @type {(inputs: Ad_Template_Min_Gap_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Introduzca el hueco mínimo (en segundos) entre eventos. Los huecos iguales o superiores a este valor obtendrán un nuevo evento de AD.`)
};

const zh_cn2_ad_template_min_gap_text = /** @type {(inputs: Ad_Template_Min_Gap_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`输入事件之间的最小间隔（秒）。等于或大于此值的间隔将创建新的AD事件。`)
};

const ja_ad_template_min_gap_text = /** @type {(inputs: Ad_Template_Min_Gap_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`イベント間の最小ギャップ（秒）を入力してください。この値以上のギャップには新しいADイベントが作成されます。`)
};

const hi_ad_template_min_gap_text = /** @type {(inputs: Ad_Template_Min_Gap_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`इवेंट्स के बीच न्यूनतम अंतराल (सेकंड में) दर्ज करें। इस मान के बराबर या उससे अधिक अंतराल पर एक नया AD इवेंट बनेगा।`)
};

const pt_pt2_ad_template_min_gap_text = /** @type {(inputs: Ad_Template_Min_Gap_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Introduza o intervalo mínimo (em segundos) entre eventos. Intervalos iguais ou superiores a este valor receberão um novo evento de AD.`)
};

/**
* | output |
* | --- |
* | "Enter the minimum gap (in seconds) between events. Gaps at or above this value will get a new AD event." |
*
* @param {Ad_Template_Min_Gap_TextInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ad_template_min_gap_text = /** @type {((inputs?: Ad_Template_Min_Gap_TextInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ad_Template_Min_Gap_TextInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_ad_template_min_gap_text(inputs)
	if (locale === "de") return de_ad_template_min_gap_text(inputs)
	if (locale === "it") return it_ad_template_min_gap_text(inputs)
	if (locale === "ru") return ru_ad_template_min_gap_text(inputs)
	if (locale === "es") return es_ad_template_min_gap_text(inputs)
	if (locale === "zh-CN") return zh_cn2_ad_template_min_gap_text(inputs)
	if (locale === "ja") return ja_ad_template_min_gap_text(inputs)
	if (locale === "hi") return hi_ad_template_min_gap_text(inputs)
	if (locale === "pt-PT") return pt_pt2_ad_template_min_gap_text(inputs)
	return en_ad_template_min_gap_text(inputs)
});